import React, { useState } from 'react'
import { useLoginMutation } from '../../../redux/API/LoginApi'
import { Link, useNavigate } from 'react-router-dom'
import toast, { Toaster } from 'react-hot-toast'
import logo from '../../assest/ghumlog.jpeg'
import { FaEye, FaEyeSlash } from 'react-icons/fa6'
import { useDispatch } from 'react-redux'
import { loginSuccess } from '../../../redux/reducer/reducer'
const Login = () => {
const [userData, setUserData] = useState({
    email: "",
    password: ""
}) 
const [emailError, setEmailError] = useState("")
const [passwordError, setPasswordError] = useState("")
const [showPass, setShowPass] = useState(true)
const navigate = useNavigate()
const [postLogin] = useLoginMutation()
const dispatch = useDispatch()
const handleLogin = (e) => {
    e.preventDefault()
    if(userData.email === ""){
        setEmailError("Please Provide Email")
        setTimeout(() => {
            setEmailError("")
        }, 4000);
        return
    }
    if(userData.password === ""){
        setPasswordError("Please Provide Password")
        setTimeout(() => {
            setPasswordError("")
        }, 4000);
        return
    }
    postLogin(userData).then((res) => {
        if(res?.data?.message === "Login successful."){
             setUserData({
                email: "",
                password: ""
            }) 
            sessionStorage.setItem("userData", JSON.stringify(res?.data))
            dispatch(loginSuccess())
            navigate("/admin/dashboard")
            
        }
        else if(res?.error){
            toast.error(res?.error?.data?.message || "Invalid Credential")
        }
        else{
            toast.error("Something went wrong, Please try later")
        }
    })
    .catch((err) => {
        console.log(err);
        
    })
}

const handlePassShow = () => {
    setShowPass(!showPass)
}

  return (
    <>
    <Toaster position='top-right'/>
    <div className="container min-vh-100">
        <div className="row min-vh-100">
            <div className="col-12 d-flex flex-column align-items-center justify-content-center">
                  <div className='text-center mb-3'>
                  <img src={logo} alt="Ghumne Jao" width={200} />
                  </div>
                <form className='login_form card p-4' onSubmit={handleLogin}>
                    <h2 className='text-center mb-5'>LOGIN</h2>
                   <div className='mb-3'>
                    <label htmlFor="email" className='d-block'>Email Address</label>
                    <input type="email" name='email' id="email" placeholder='Enter Email' className="form-control" value={userData.email} onChange={(e) => setUserData({...userData, email: e.target.value})}/>
                    {
             emailError && (
                <p className="text-danger wel mt-1 mb-0">{emailError}</p>
              )
             }
                   </div>
                   <div className='mb-4 position-relative'>
                    <label htmlFor="password" className='d-block'>Password</label>
                    <input type={showPass ? "password" : "text"} name='password' id='password' placeholder='Enter Password' className="form-control" 
                    value={userData.password} onChange={(e) => setUserData({...userData, password: e.target.value})}
                    />
                    
                        <span className='position-absolute top-50 translate-x-50 end-0 me-3' onClick={handlePassShow}>
                            {
                        showPass ? 
                        <Link ><FaEye/></Link>
                        : 
                        <Link><FaEyeSlash /></Link>
                    }
                        </span>
                     {
             passwordError && (
                <p className="text-danger wel mt-1 mb-0">{passwordError}</p>
              )
             }
                   </div>
                   <div className='text-center'>
                    <button className='btn btn-primary px-4 rounded-2' type='submit'>LOGIN</button>
                   </div>
                </form>
            </div>
        </div>
    </div>
    </>
  )
}

export default Login